import { Modal } from "antd";
import Back from "Components/Back";
import Button from "Components/Button";
import { useGetSingleCreditManagementQuery } from "hooks/CreditManagement/useGetSingleCreditManagementQuery";
import { useDeleteDiscountMutation } from "hooks/DiscountManagement/useDeleteDiscountMutation";
import { useGetSingleDiscountQuery } from "hooks/DiscountManagement/useGetSingleDiscountQuery";
import { usePublishDiscountMutation } from "hooks/DiscountManagement/usePublishDiscountMutation";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
// import ApproveInterface from "./forms/ApproveInterface";
// import ReviewInterface from "./forms/ReviewInterface";
// import DeclineInterface from "./forms/DeclineInterface";

const Header = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  //   const { data, isPending } = useGetSingleCreditManagementQuery(`${id}`);
  const [active, setActive] = useState("");

  const initialState = { status: false, title: "" };

  const { id } = useParams();
  const {
    data: discount,
    isPending,
    isError,
  } = useGetSingleDiscountQuery(`${id}`);

  const closeModal = () => {
    setActivity(initialState);
  };

  const { mutateAsync, isPending: isDeleting } = useDeleteDiscountMutation();
  const { mutateAsync: publishAsync, isPending: isPublishing } =
    usePublishDiscountMutation();
  const [activity, setActivity] = useState(initialState);

  const handleDelete = () => {
    mutateAsync(id, {
      onSuccess: () => {
        setActivity(initialState);
      },
    });
  };

  const handlePublish = () => {
    publishAsync(id, {
      onSuccess: () => {
        setActivity(initialState);
      },
    });
  };

  return (
    <div className="mt-[20px] border-[1px] border-[#eeeeee] p-3 rounded-[10px] mb-3">
      <div className="flex items-center justify-between">
        <span className="flex gap-2 items-center">
          <Back />
          <div className="flex gap-2 items-center ml-4">
            <span className="text-primary-foreground">Discount Management</span>
            <Right />
            <span className="text-primary-foreground">Details</span>
          </div>
        </span>
        <span className="">
          <div className="flex items-center justify-between">
            <span className="flex flex-row gap-1">
              <Link
                to={`/discount-management/edit/${id}`}
                className="text-[#414141] rounded-md bg-[#FFF5F0] p-3 text-[14px]"
              >
                Update
              </Link>
              {/* {data?.data?.status === "pending" ||
                (data?.data?.status === "in_review" && ( */}
              <button
                onClick={() => setActivity({ title: "publish", status: true })}
                className="text-[#414141] rounded-md bg-[#FFF5F0] p-3 text-[14px]"
              >
                Publish
              </button>

              {discount?.data?.isDeleted !== true && (
                <button
                  onClick={() => setActivity({ title: "delete", status: true })}
                  className="text-[#414141] rounded-md bg-[#f3f3f3] p-3 text-[14px]"
                >
                  Delete
                </button>
              )}
            </span>
          </div>
        </span>
        <Modal
          title={
            <span className="mt-2">{`${
              activity?.title === "delete"
                ? "Delete Discount"
                : activity?.title === "publish"
                ? "Publish Discount"
                : activity?.title === "update"
                ? "Update Discount"
                : ""
            }`}</span>
          }
          open={activity?.status}
          onClose={() => setActivity(initialState)}
          footer={null}
          closeIcon={false}
        >
          {activity?.title === "delete" && (
            <div>
              <p className="mb-3">
                Confirm if you'd like to delete this discount
              </p>
              <div className="flex gap-2">
                <button
                  className="bg-white border border-orange text-orange p-3 rounded-md w-full font-bold"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <Button
                  label="Delete"
                  className="bg-red-600"
                  isLoading={isDeleting}
                  onClick={handleDelete}
                />
              </div>
            </div>
          )}{" "}
          {activity?.title === "publish" && (
            <div>
              <p className="mb-3">
                Confirm if you'd like to publish this discount
              </p>
              <div className="flex gap-2">
                <button
                  className="bg-white border border-orange text-orange p-3 rounded-md w-full font-bold"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <Button
                  label="Publish"
                  className="bg-red-600"
                  isLoading={isPublishing}
                  onClick={handlePublish}
                />
              </div>
            </div>
          )}
          {activity?.title === "update" && "UPDATE"}
        </Modal>
      </div>
    </div>
  );
};

export default Header;

const Right = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-4 text-primary-foreground"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m8.25 4.5 7.5 7.5-7.5 7.5"
      />
    </svg>
  );
};
